import { render } from "./CustomAreaBasicEdit.vue?vue&type=template&id=a6182e02"
import script from "./CustomAreaBasicEdit.vue?vue&type=script&lang=js"
export * from "./CustomAreaBasicEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__